import { render, staticRenderFns } from "./DriverModal.vue?vue&type=template&id=12d918c2&scoped=true&"
import script from "./DriverModal.vue?vue&type=script&lang=ts&"
export * from "./DriverModal.vue?vue&type=script&lang=ts&"
import style0 from "./DriverModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DriverModal.vue?vue&type=style&index=1&id=12d918c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d918c2",
  null
  
)

export default component.exports